import { Box, Button, Stack, Typography } from '@mui/material';
import FeedbacksDeleteIcon from '@/assets/images/svg/feedbacks-delete.svg';
import { BaseDialog } from '@/components/shared/base-dialog';

type DeleteConfirmDialogProps = {
  onClose: () => void;
  onSubmit: () => void;
};

const Actions = ({ onClose, onSubmit }: DeleteConfirmDialogProps) => (
  <Stack spacing={2} direction="row" justifyContent="flex-end">
    <Button onClick={onClose}>Não</Button>
    <Button variant="contained" onClick={onSubmit}>
      Sim
    </Button>
  </Stack>
);

export const DeleteConfirmDialog = ({
  onClose,
  onSubmit,
}: DeleteConfirmDialogProps) => {
  return (
    <BaseDialog
      actionsComponent={<Actions onClose={onClose} onSubmit={onSubmit} />}
      fullWidth
      maxWidth="xs"
      onClose={onClose}
      open
      title="Remover o feedback atualizará suas habilidades"
      icon={
        <Box
          component="img"
          src={FeedbacksDeleteIcon}
          sx={{ height: 60, width: 60 }}
        />
      }
    >
      <Typography>
        Ao continuar, as habilidades serão removidas e você perderá as
        habilidades selecionadas. Tem certeza de que deseja continuar?
      </Typography>
    </BaseDialog>
  );
};
